<div #tag
     [class.-clickable]="clickable"
     [style.background-color]="color" [style.color]="textColor" [title]="tag.innerText" class="tag-label" [ngClass]="{'-tag-select': tagSelect}" data-testid="tag">
  <span class="name"><ng-content></ng-content></span>
</div>
